import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { authManager } from '../utils/auth';

const Base_Url = process.env.REACT_APP_API_BASE_URL;

const Brand_View = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [brand, setBrand] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });


        const fetchBrand = async () => {
            try {
                const res = await authManager.authenticatedFetch(`${Base_Url}/shopping/brands/${id}`);
                if (!res.ok) throw new Error("Fetch failed");
                const data = await res.json();
                setBrand(data.result);
            } catch (err) {
                console.error("Failed to load brand:", err);
                navigate('/login');
            } finally {
                setLoading(false);
            }
        };

        fetchBrand();
    }, [id, navigate]);

    if (!loading && !brand) {
        return <div className="text-center mt-5">Brand not found.</div>;
    }

    return (
        <div>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2 align-items-center">
                        <div className="col-6 col-sm-6">
                            <h1 className="m-0 txt_lft">Brand Details</h1>
                        </div>
                        <div className="col-6 col-sm-6">
                            <ol className="breadcrumb justify-content-end">
                                <li className="breadcrumb-item">
                                    <Link to="/brands"><i className="fa-solid fa-arrow-left-long" /> Back</Link>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="frmwdth_cntr col-lg-12">
                            <div className="card card-primary card-outline">
                                {loading ? (
                                    <div className="card-body text-center">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <form className="form-horizontal">
                                        <div className="card-body">
                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Name</label>
                                                <div className="col-md-8">{brand.name || '-'}</div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Logo</label>
                                                <div className="col-md-8">
                                                    <img
                                                        src={brand.brandLogo || "/assets/img/brands/no_brand.png"}
                                                        alt="Brand Logo"
                                                        style={{ maxHeight: "60px", maxWidth: "200px" }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Affiliate Platforms</label>
                                                <div className="col-md-8">{brand.network || '-'}</div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Description</label>
                                                <div className="col-md-8">
                                                    <div>{brand.description || '-'}</div>
                                                </div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Address</label>
                                                <div className="col-md-8">{brand.address || '-'}</div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Phone</label>
                                                <div className="col-md-8">{brand.phoneNumber || '-'}</div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Email</label>
                                                <div className="col-md-8">{brand.email || '-'}</div>
                                            </div>

                                            <div className="form-group row">
                                                <label className="col-md-4 col-form-label">Social Media</label>
                                                <div className="col-md-8">
                                                    <div className="socialmedia_network">
                                                        {brand.socialLinks && Object.values(brand.socialLinks).some(val => val) ? (
                                                            <>
                                                                {brand.socialLinks.facebook && <a href={brand.socialLinks.facebook}><i className="fa-brands fa-facebook-f" /></a>}
                                                                {brand.socialLinks.twitter && <a href={brand.socialLinks.twitter}><i className="fa-brands fa-x-twitter" /></a>}
                                                                {brand.socialLinks.linkedin && <a href={brand.socialLinks.linkedin}><i className="fa-brands fa-linkedin-in" /></a>}
                                                                {brand.socialLinks.pinterest && <a href={brand.socialLinks.pinterest}><i className="fa-brands fa-pinterest-p" /></a>}
                                                                {brand.socialLinks.youtube && <a href={brand.socialLinks.youtube}><i className="fa-brands fa-youtube" /></a>}
                                                                {brand.socialLinks.instagram && <a href={brand.socialLinks.instagram}><i className="fa-brands fa-instagram" /></a>}
                                                                {brand.socialLinks.threads && <a href={brand.socialLinks.threads}><i className="fa-brands fa-threads" /></a>}
                                                            </>
                                                        ) : (
                                                            '-'
                                                        )}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer text-center">
                                            <Link to={`/brandsedit/${brand._id}`} className="btn btn-blue mr-2">Edit</Link>
                                            <button type="button" className="btn btn-danger">Delete</button>
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Brand_View;
